import {Colors} from 'styles/Colors';

interface Props {
  color?: string;
}

const CloseIcon = ({color = Colors.BROWN_GREY}: Props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
    <g fill="none" fillRule="evenodd">
      <path fillRule="nonzero" d="M-5-5h24v24H-5z" />
      <path stroke={color} strokeLinejoin="round" strokeWidth="2" d="M13 1L1 13M1 1l12 12" />
    </g>
  </svg>
);

export default CloseIcon;
